import { useCreateEntityElement } from 'client/context/CreateEntityContext'
import { getChildrenEntities } from 'client/reducers/pageReducer'
import React, { memo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { CommonWebsiteLayoutBody } from 'src/shared/entities/website-layout-body'
import { WebsiteLayoutBodyInterface } from 'src/shared/types/website-entities'

export interface WebsiteLayoutBodyProps {
  entity: WebsiteLayoutBodyInterface
}

export const WebsiteLayoutBody = memo(({ entity }: WebsiteLayoutBodyProps) => {
  const { createEntityElement } = useCreateEntityElement()
  const layoutEntities = useSelector(
    // biome-ignore lint/suspicious/noExplicitAny: @TODO move selectors to typescript
    (state: any) => getChildrenEntities(state.page.present, entity.childIds),
    shallowEqual,
  )

  const header = createEntityElement(layoutEntities[0])
  const footer = createEntityElement(layoutEntities[1])
  const content = createEntityElement(layoutEntities[2])

  return (
    <CommonWebsiteLayoutBody
      header={header}
      content={content}
      footer={footer}
    />
  )
})
